import React from 'react';
import { withRouter } from 'react-router-dom';

import { scrollIntoView } from '../../lib/utils';

type History = {
  location: {
    hash: string,
  },
};

type Props = {
  history: History,
};

class HashLinkIntoView extends React.Component<Props> {
  componentDidMount() {
    this.scrollToHashLink();
  }

  scrollToHashLink = () => {
    const { hash } = this.props.history.location;

    if (hash) this.scrollToHashTimeoutId = setTimeout(() => scrollIntoView(hash), 1000);
  };

  clearTimeouts = () => {
    if (this.scrollToHashTimeoutId) clearTimeout(this.scrollToHashTimeoutId);
  };

  componentWillUnmount() {
    this.clearTimeouts();
  }

  render() {
    return null;
  }
}

export default withRouter(HashLinkIntoView);



// WEBPACK FOOTER //
// ./src/components/HashLinkIntoView/HashLinkIntoView.js